"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _lodash = require("lodash");
var _user = _interopRequireDefault(require("./user"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _date_decorator = _interopRequireDefault(require("./date_decorator"));
var _membership = _interopRequireDefault(require("./membership"));
var _payment = _interopRequireDefault(require("./payment"));
var _promotion = _interopRequireDefault(require("./promotion"));
var _prorated_refund_policy = _interopRequireDefault(require("./prorated_refund_policy"));
var _constants = require("@seedlang/constants");
var _utils = require("@seedlang/utils");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var Subscription = (_dec = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec2 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec3 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec4 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec5 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec6 = (0, _serializr.serializable)((0, _serializr.object)(_membership["default"])), _dec7 = (0, _serializr.serializable)((0, _serializr.object)(_promotion["default"])), _dec8 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_user["default"]))), _dec9 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_payment["default"]))), _dec10 = (0, _serializr.serializable)((0, _serializr.object)(_prorated_refund_policy["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function Subscription() {
    var _this;
    _classCallCheck(this, Subscription);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Subscription, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "amount", _descriptor2, _this);
    _initializerDefineProperty(_this, "amountUsd", _descriptor3, _this);
    _initializerDefineProperty(_this, "currency", _descriptor4, _this);
    _initializerDefineProperty(_this, "name", _descriptor5, _this);
    _initializerDefineProperty(_this, "cancelAtPeriodEnd", _descriptor6, _this);
    _initializerDefineProperty(_this, "paymentMethod", _descriptor7, _this);
    _initializerDefineProperty(_this, "paymentsCount", _descriptor8, _this);
    _initializerDefineProperty(_this, "refunded", _descriptor9, _this);
    _initializerDefineProperty(_this, "pending", _descriptor10, _this);
    _initializerDefineProperty(_this, "cancellationReason", _descriptor11, _this);
    _initializerDefineProperty(_this, "cancellationMessage", _descriptor12, _this);
    _initializerDefineProperty(_this, "stripeCustomerId", _descriptor13, _this);
    _initializerDefineProperty(_this, "stripeAccount", _descriptor14, _this);
    _initializerDefineProperty(_this, "cancellationConfirmed", _descriptor15, _this);
    _initializerDefineProperty(_this, "refundConfirmed", _descriptor16, _this);
    _initializerDefineProperty(_this, "transactionId", _descriptor17, _this);
    _initializerDefineProperty(_this, "originalTransactionId", _descriptor18, _this);
    _initializerDefineProperty(_this, "mergedTransactionId", _descriptor19, _this);
    _initializerDefineProperty(_this, "membershipTypeId", _descriptor20, _this);
    _initializerDefineProperty(_this, "automaticRenewal", _descriptor21, _this);
    _initializerDefineProperty(_this, "targetLanguageId", _descriptor22, _this);
    _initializerDefineProperty(_this, "deletedUser", _descriptor23, _this);
    _initializerDefineProperty(_this, "oneTimePayment", _descriptor24, _this);
    _initializerDefineProperty(_this, "membershipGroupName", _descriptor25, _this);
    _initializerDefineProperty(_this, "relativeCreationDateOfUser", _descriptor26, _this);
    _initializerDefineProperty(_this, "cancelledAt", _descriptor27, _this);
    _initializerDefineProperty(_this, "trialEnd", _descriptor28, _this);
    _initializerDefineProperty(_this, "createdAt", _descriptor29, _this);
    _initializerDefineProperty(_this, "currentPeriodStart", _descriptor30, _this);
    _initializerDefineProperty(_this, "currentPeriodEnd", _descriptor31, _this);
    _initializerDefineProperty(_this, "membership", _descriptor32, _this);
    _initializerDefineProperty(_this, "promotion", _descriptor33, _this);
    _initializerDefineProperty(_this, "users", _descriptor34, _this);
    _initializerDefineProperty(_this, "payments", _descriptor35, _this);
    _initializerDefineProperty(_this, "siteId", _descriptor36, _this);
    _initializerDefineProperty(_this, "proratedRefundPolicy", _descriptor37, _this);
    return _this;
  }
  _inherits(Subscription, _RootModel);
  return _createClass(Subscription, [{
    key: "amountFormatted",
    get: function get() {
      return "".concat(this.currencySymbol).concat((this.amount / 100).toFixed(2));
    }
  }, {
    key: "amountUsdFormatted",
    get: function get() {
      return this.amountUsd ? "$".concat((this.amountUsd / 100).toFixed(2)) : '-';
    }
  }, {
    key: "currencySymbol",
    get: function get() {
      if ((0, _utils.isPresent)(this.currency)) {
        return (0, _utils.isPresent)(_constants.Constants.CURRENCY_SYMBOLS[this.currency.toUpperCase()]) ? _constants.Constants.CURRENCY_SYMBOLS[this.currency.toUpperCase()] : this.currency;
      }
      return '$';
    }
  }, {
    key: "isActive",
    get: function get() {
      var _this$currentPeriodSt;
      // Same logic as in rails/app/models/computed_subscription_status.rb #best_subscription
      return ((_this$currentPeriodSt = this.currentPeriodStart) === null || _this$currentPeriodSt === void 0 ? void 0 : _this$currentPeriodSt.isBeforeOneDayFromNow) && (!this.currentPeriodEnd || this.currentPeriodEnd.isFuture);
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "amount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "amountUsd", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "currency", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "name", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "cancelAtPeriodEnd", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "paymentMethod", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "paymentsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "refunded", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "pending", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "cancellationReason", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "cancellationMessage", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "stripeCustomerId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "stripeAccount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "cancellationConfirmed", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "refundConfirmed", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "transactionId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "originalTransactionId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "mergedTransactionId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "membershipTypeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "automaticRenewal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "targetLanguageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "deletedUser", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "oneTimePayment", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "membershipGroupName", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "relativeCreationDateOfUser", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "cancelledAt", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "trialEnd", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "currentPeriodStart", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "currentPeriodEnd", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "membership", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "promotion", [_mobx.observable, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "users", [_mobx.observable, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "payments", [_mobx.observable, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "siteId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "proratedRefundPolicy", [_mobx.observable, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "amountFormatted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "amountFormatted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "amountUsdFormatted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "amountUsdFormatted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currencySymbol", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currencySymbol"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isActive", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isActive"), _class.prototype), _class);
var _default = exports["default"] = Subscription;